var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"view--guide-details"},[[_c('visitor-details-header',{attrs:{"visitor-id":_vm.decodedVisitorId}}),_c('visitor-details-content',{attrs:{"visitor-id":_vm.decodedVisitorId}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }